import { login, getData } from '@/apis/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
	return {
		token: getToken(),
		username: '',
		phone: '',
		avatar: '',
		company: '',
		// 0 游客 1 免费会员 2 普通会员 3 高级会员 4 VIP会员
		user_group: 0
	}
}

const state = getDefaultState()

const mutations = {
	RESET_STATE: (state) => {
		Object.assign(state, getDefaultState())
	},
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_USERNAME: (state, username) => {
		state.username = username
	},
	SET_PHONE: (state, phone) => {
		state.phone = phone
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_COMPANY: (state, company) => {
		state.company = company
	},
	SET_USER_GROUP: (state, user_group) => {
		state.user_group = user_group
	},
}

const actions = {
	// user login
	login({ commit }, state) {
		return new Promise((resolve, reject) => {
			login(state).then(response => {
				if (response.code === 200) {
					const { data } = response;
					commit('SET_TOKEN', data.token);
					commit('SET_USERNAME', data.username);
					commit('SET_PHONE', data.phone);
					commit('SET_AVATAR', data.avatar);
					commit('SET_USER_GROUP', data.user_group);
					localStorage.setItem("loginFirstTime", new Date().getTime());
					setToken(data.token);
					resolve();
				} else {
					reject(response)
				}
			}).catch(error => {
				reject(error)
			})
		})
	},
	// get user info
	getInfo({ commit }, state) {
		return new Promise((resolve, reject) => {
			getData().then(response => {
				if (response.code === 200) {
					const { data } = response;
					const { username, phone, avatar, company } = data;
					commit('SET_USERNAME', username);
					commit('SET_PHONE', phone);
					commit('SET_AVATAR', avatar);
					commit('SET_COMPANY', company);
					commit('SET_TOKEN', getToken());
					commit('SET_USER_GROUP', state.user_group);
					resolve(data)
				} else {
					reject(response)
				}
			}).catch(error => {
				console.log(error);
				reject(error)
			})
		})
	},
	// user logout
	logout({ commit, state }) {
		removeToken() // must remove  token  first
		resetRouter()
		commit('RESET_STATE')
		// 清空本地存储中的登录时间
		localStorage.removeItem("loginFirstTime");
	},
	// remove token
	resetToken({ commit }) {
		return new Promise(resolve => {
			removeToken() // must remove  token  first
			commit('RESET_STATE')
			resolve()
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js